<rappider-crud-detail [data]="moduleData"></rappider-crud-detail>